import styled from "styled-components";

export const TrackingPixelContainer = styled.div`
  max-width: 87.5rem;
  overflow: hidden;
  height: 100vh;
  width: 100%;

  margin: 2rem auto;
  padding: 0 2rem;

  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`

export const TrackingPixelHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 2rem;

  @media (max-width: 650px) {
    flex-direction: column;
    gap: 1.5rem;
  }

`

export const CreateTrackingPixelButton = styled.button `
    display: flex;
    padding: .75rem 1.5rem;
    justify-content: center;
    align-items: center;
    gap: .625rem;

    border-radius: .25rem;
    border: none;
    background: #0073E5;

    font-family: Inter;
    font-size: .825rem;
    font-style: normal;
    font-weight: 600;
    color: ${(props) => props.theme.controlPanel.quaternaryTextControlPanel};

    cursor: pointer;

    @media (max-width: 767px) {
      padding: .75rem 1.5rem;
    }

`

export const TitlePixel = styled.h1`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 400px;
  color: ${({ theme }) => theme.controlPanel?.textControlPanel};
  font: 600 1.25rem/1.875rem "Inter";
  margin: 0;
` 
